import {
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  makeStyles,
} from '@material-ui/core';
import Button from 'components/Button/Button';
import DialogHeader from 'components/DialogHeader/DialogHeader';
import React from 'react';
import { useTranslation } from 'react-i18next';

export const ArchiveProjectDialog = ({
  closeArchiveProjectDialog,
  handleArchiveProject,
}) => {
  const useStyles = makeStyles((theme) => ({
    dialogPaper: {
      ...theme.component.dialogPaper,
      [theme.breakpoints.down('xs')]: {
        ...theme.component.dialogPaperFullscreen,
      },
    },
    dialogContent: {
      paddingTop: theme.spacing(2),
    },
    dialogActions: {
      paddingLeft: theme.spacing(1.5),
      paddingRight: theme.spacing(1.5),
    },
    listAttribute: {
      marginBottom: '10px',
    },
  }));

  const { t } = useTranslation('common');

  const classes = useStyles();

  const onClose = () => {
    closeArchiveProjectDialog();
  };

  return (
    <Dialog
      classes={{ paper: classes.dialogPaper }}
      fullWidth
      maxWidth="sm"
      open={true}
    >
      <DialogHeader
        title="Vahvista projektin arkistointi"
        onClose={() => onClose()}
      />
      <DialogContent className={classes.dialogContent}>
        <p>{t('project.archive_project_description')}</p>
      </DialogContent>
      <Divider />
      <DialogActions className={classes.dialogActions}>
        <Button elevated onClick={() => handleArchiveProject()}>
          {t('common.confirm')}
        </Button>
        <Button onClick={() => onClose()}>{t('common.close')}</Button>
      </DialogActions>
    </Dialog>
  );
};
